import { Component, OnInit } from '@angular/core';
import { AuthService, JwtPayload } from '../auth.service';

@Component({
    selector: 'account-disabled',
    templateUrl: './account-disabled.component.html',
    styleUrls: ['./account-disabled.component.css'],
    standalone: false
})
export class AccountDisabledComponent implements OnInit{

  disabled: boolean = true;

  constructor(private authService: AuthService){}

  async checkStatus(){
    const response = await this.authService.checkAccountStatus();
    const jwt: JwtPayload = this.authService.decodeToken(response.token);
    this.disabled = jwt.disabled;
    if(!jwt.disabled){
      this.authService.storeAuthToken(response);
    }
  }

  async ngOnInit(): Promise<void> {
    this.checkStatus();
  }

}
